import React from 'react';
import { MIcon } from '../Icon';
import { useStyletron } from '../../Themes';
import { CardGeneralStyles, cardRootStyle } from './styles';
import { marginSize, paddingSize } from '../../Utilities/utils/Theming';
import * as meta from '../../meta-data.json';
import { IDummyProps } from './types';

export const overrides = (props: IDummyProps, ref: any) => {
	const CardTitle = () => {
		const [css]: any = useStyletron();

		if (props.hideHeader) return null;

		const withEllipsis = props.headerEllipsis
			? {
					textOverflow: 'ellipsis',
					width: '100%',
					overflow: 'hidden',
					wordBreak: 'break-all',
					whiteSpace: 'pre',
			  }
			: {};

		const spacingSizeValue =
			props.size === 'compact' ? 'var(--epods--space-inset-s)' : 'var(--epods--space-inset-m)';

		return (
			<>
				<div
					className={css({
						...paddingSize(spacingSizeValue, spacingSizeValue, spacingSizeValue, spacingSizeValue),
						display: 'flex',
						alignItems: 'center',
						flex: '0 0 auto',
						backgroundColor: props.headerBackground || 'var(--epods--color-bg)',
					})}
				>
					{props.icon && typeof props.icon == 'string' && (
						<MIcon
							icon={props.icon || 'home'}
							color={props.color || 'var(--epods--color-text-ds-blue)'}
							size={'medium'}
							className={css({
								marginRight: 'var(--epods--card-header-icon-margin)',
								alignSelf: 'center',
							})}
						/>
					)}
					{typeof props.icon != 'string' && props.icon}
					<div
						className={css({
							...withEllipsis,
							fontWeight: 100,
							color: 'var(--epods--color-text-primary)',
							fontFamily: 'var(--epods--font-base)', //theme.card.headerFontFont,
							lineHeight: 'var(--epods--line-height-h4)', //theme.card.headerFontHeight,
							fontSize: 'var(--epods--font-size-h4)', //theme.card.headerFontSize,
							display: 'display',
							paddingRight: 'var(--epods--space-inset-s)',
							flexGrow: 1,
						})}
					>
						{props.header}
					</div>
				</div>
				<div
					className={css({
						...marginSize('0px', spacingSizeValue, '0px', spacingSizeValue),
						height: '1px',
						backgroundColor: !props.hideSeparator ? 'var(--epods--color-border-light)' : 'transparent',
					})}
				/>
			</>
		);
	};

	return {
		Root: {
			style: cardRootStyle(props),
			props: {
				'data-epo': `epo-card-${meta.version}`,
				part: `epo-card-${meta.version}`,
				className: props.className,
				ref: ref,
			},
		},

		Contents: {
			style: {
				...CardGeneralStyles.cardContentStyle(),
				...props.contentStyles,
			},
			props: {
				...props.contentProps,
			},
		},

		Body: {
			style: CardGeneralStyles.cardBodyStyle(props.size, props.hideHeader),
		},

		Title: {
			component: CardTitle,
		},
	};
};
